import React, {useEffect, useRef, useState} from 'react';
import CardHeader from '../../components/common/card-header/CardHeader';
import {
    FlexItem,
    FlexLayout,
    StackLayout, Text, Card, Spinner,
} from '@salt-ds/core';
import StepTracker from '../../components/common/StepTracker';

import '../CommonCard.css';

import Constants from '../../components/common/Constants';
import CardAlert from "../../components/common/card-alert/CardAlert";
import ChangePasswordComponent from '../../components/common/ChangePasswordComponent';
import PageNavigationCustom from "../../components/common/page-navigation/PageNavigationCustom";
import {useLocation, useNavigate} from 'react-router';
import {useIntl} from 'react-intl';

function ForgotPasswordComplete() {

    const formRef = useRef();
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const mainRef = useRef(null);
    const intl = useIntl();

    const handleNextButtonClick = () => {
        if(formRef.current) {
            formRef.current.submitForm();
        }
    }
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        // Set focus to main element for screen reader announcement
        if (mainRef.current) {
            mainRef.current.focus();
        }

        const expectedPreviousPage = '/forgotPasswordProvideAccessCode';
        if (location.state?.from !== expectedPreviousPage) {
            navigate('/');
        }
    }, [navigate,location]);
    return (
        <main ref={mainRef} role="main" aria-label="Forgot Password Complete" tabIndex="-1">
        <FlexLayout className={"page-content"}>
            {isLoading ? (
                <FlexItem className="spinner-wrapper">
                    <Spinner data-testid="spinner-loading" aria-label="loading" role="status" size="medium" style={{marginLeft: "50%"}} />
                </FlexItem>
            ) : (
                <FlexItem  className={`error-wrapper ${hasError ? 'visible' : ''}`}>
                    <div>
                        <CardAlert status={"error"} setHasError={setHasError}>
                            {errorMessage}
                        </CardAlert>
                    </div>
                </FlexItem>
            )}
            <FlexItem>
                <Card className={"card-wrapper"}>
                    <FlexItem className="card-content">
                        <StackLayout gap={3}>

                            <CardHeader style={{maxWidth: '15.5rem'}} heading={Constants.forgotPasswordTitle}
                                        subheading={Constants.forgotPasswordStep3Title}/>

                            <StepTracker label1={intl.formatMessage({id: 'logon.ui.forgotpassword.flow.step1'})} step1="completed"
                              label2={intl.formatMessage({id: 'logon.ui.forgotpassword.flow.step2'})} step2="completed"
                              label3={intl.formatMessage({id: 'logon.ui.forgotpassword.flow.step3'})} step3="active" />
                            <FlexItem>
                                <Text>
                                    {Constants.forgotPasswordStep3InstructionHeader}
                                </Text>
                            </FlexItem>
                            <ChangePasswordComponent
                                redirectUrl={Constants.forgotPasswordSuccess}
                                ref={formRef}
                                isForgotPasswordFlow={true}
                                isLoading={isLoading}
                                setIsLoading={setIsLoading}
                            />
                            <PageNavigationCustom isCancelNotAllowed={false} backButton={true} previousPage={"forgotPasswordProvideAccessCode"} onSubmit={handleNextButtonClick} isLoading={isLoading}/>
                        </StackLayout>
                    </FlexItem>
                </Card>
            </FlexItem>
        </FlexLayout>
        </main>
    );

}

export default ForgotPasswordComplete;